import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function CloseSection() {
  return <section id="checkout" className="py-14 lg:py-24 px-4 sm:px-6 lg:px-8 bg-white relative overflow-hidden" data-id="element-32">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-cream via-white to-white opacity-60" data-id="element-33"></div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-34">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-35">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-charcoal mb-5 lg:mb-8 font-serif leading-tight" data-id="element-36">
            Tu viaje a China no debería empezar con una pelea con el móvil.
          </h2>

          <p className="text-lg lg:text-xl text-charcoal-light mb-5 lg:mb-8 max-w-2xl mx-auto" data-id="element-37">
            Debería empezar con 3 cosas claras:{' '}
            <span className="font-bold text-china-red" data-id="element-38">conexión</span>,{' '}
            <span className="font-bold text-china-red" data-id="element-39">pago</span>,{' '}
            <span className="font-bold text-china-red" data-id="element-40">ruta</span>.
          </p>

          <p className="text-base lg:text-lg text-charcoal/80 mb-8 lg:mb-12 italic" data-id="element-41">
            Si quieres que tu primer día sea aburrido (en el buen sentido), este
            PDF es para ti.
          </p>

          <div className="flex flex-col items-center" data-id="element-42">
            <motion.button whileHover={{
            scale: 1.05,
            boxShadow: '0 20px 25px -5px rgba(155, 27, 48, 0.4)'
          }} whileTap={{
            scale: 0.98
          }} className="px-10 py-5 bg-china-red text-cream font-bold text-xl rounded-full shadow-xl hover:bg-china-red-dark transition-all duration-300 flex items-center group mb-6" data-id="element-43">
              Descargar China Sin Estrés (2026)
              <ArrowRight className="ml-2 h-6 w-6 group-hover:translate-x-1 transition-transform" data-id="element-44" />
            </motion.button>

            <div className="flex items-center space-x-2 text-sm text-charcoal/60" data-id="element-45">
              <span className="w-2 h-2 bg-green-500 rounded-full" data-id="element-46"></span>
              <span data-id="element-47">Pago seguro · Descarga inmediata · Acceso de por vida</span>
            </div>

            <div className="mt-8 lg:mt-12 max-w-md mx-auto" data-id="element-48">
              <img src="https://cdn.magicpatterns.com/uploads/8xcAtDHpbbekfhEgrmZkfc/heylloyd-image-1770828272691.png" alt="China Sin Estrés Cover" className="w-full h-auto rounded-lg shadow-2xl transform rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-49" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}